import { render } from "./ResteProductGamme.vue?vue&type=template&id=33b24b3c&scoped=true"
import script from "./ResteProductGamme.vue?vue&type=script&lang=js"
export * from "./ResteProductGamme.vue?vue&type=script&lang=js"

import "./ResteProductGamme.vue?vue&type=style&index=0&id=33b24b3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b24b3c"]])

export default __exports__